module.exports = __webpack_public_path__ + "img/qixing.ba341683.png";